// Measure <-> beat math from a song's time signature map. The song's
// `measureNumbers` only holds every 4th marker (display spacing), so
// anything that needs a real per-measure mapping — practice sections, the
// lesson system's drills — walks the map with these instead.

{ceil, floor, max} := Math

type TimeSignatureLike =
  beat: number
  numerator: number
  denominator: number

measureBeats := (ts: {numerator: number, denominator: number}) ->
  ts.numerator * 4 / ts.denominator

// Beat where the 1-based measure starts
export beatOfMeasure := (timeSignatureMap: TimeSignatureLike[], measure: number): number ->
  b .= 0
  len .= 4
  remaining .= max 0, measure - 1

  for ts of timeSignatureMap
    break unless remaining > 0
    while remaining > 0 and b + len <= ts.beat
      b += len
      remaining--
    if remaining > 0 and ts.beat >= b
      // a signature change mid-measure starts a fresh measure at its beat
      if ts.beat > b
        b = ts.beat
        remaining--
      len = measureBeats ts
      // the event exactly at b only changes the length

  b + remaining * len

// How many (whole or partial) measures a song of `songBeatLength` beats has
export measureCount := (timeSignatureMap: TimeSignatureLike[], songBeatLength: number): number ->
  return 0 unless songBeatLength > 0
  n .= 0
  b .= 0
  len .= 4
  for ts of timeSignatureMap
    while b + len <= ts.beat and b < songBeatLength
      b += len
      n++
    if ts.beat > b and b < songBeatLength
      b = ts.beat
      n++
    len = measureBeats ts
  while b < songBeatLength
    b += len
    n++
  max 1, n
